import { useContext, useEffect } from 'react';

import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { ComparisonContext } from '../ComparisonContext';
import Trigger from './Trigger';

const Triggers = () => {
  const { isIntersecting: hidePrev, ref: prevRef } = useIntersectionObserver({
    initialIsIntersecting: true
  });

  const { isIntersecting: hideNext, ref: nextRef } = useIntersectionObserver();

  const { setShowPrev, setShowNext } = useContext(ComparisonContext);

  useEffect(() => {
    setShowPrev?.(!hidePrev);
  }, [hidePrev, setShowPrev]);

  useEffect(() => {
    setShowNext?.(!hideNext);
  }, [hideNext, setShowNext]);

  return (
    <>
      <Trigger buttonRef={prevRef} />
      <Trigger buttonRef={nextRef} next />
    </>
  );
};

export default Triggers;
